import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button } from "components/button";
import { Text } from "components/text";
import { TicketCategory } from "integrations/zendesk";

export const ManuscriptTeaser = () => {
  const { t } = useTranslation(["uploadManuscript", "general"]);

  const contactUsSearch = {
    ticketCategory: TicketCategory.feature_request,
    message: t("uploadManuscript:teaser.featureRequestMessage"),
  };

  return (
    <div className="space-y-4">
      <Text as="h2" variant="heading">
        {t("uploadManuscript:title")}
      </Text>

      <div className="flex items-center justify-center rounded-xl bg-secondary-25 px-6 py-8 space-x-3">
        <div aria-hidden>🚀</div>
        <Text as="span" variant="label">
          {t("uploadManuscript:teaser.comingSoon")}
        </Text>
        <Link
          to="/contact-us"
          search={contactUsSearch}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center"
        >
          <Button variant="tertiary" size="small">
            {t("general:contactUs")}
          </Button>
        </Link>
      </div>
    </div>
  );
};
